import {ReactNode, useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import { RootState} from "../../Store";
import { RouteLink} from "../../RouteLink";
import routes from "../../../utils/routes";
import Style from "./Style.module.scss";
import Overlay from "react-bootstrap/Overlay";
import { ClickOuterDiv} from "../../Hook/useClickOuter";
import {FrontWebRadioStreamPlaylistModel} from "../../../generated";
import {ApiClient} from "../../../generated/ApiClient";
import {QualityAction} from "../state/qualities";
import Form from "react-bootstrap/Form";

import dotmoreselectedsvg from "../../../static/dotmoreselected.svg";
import dotmoresvg from "../../../static/dotmore.svg";
import rectanglesvg from "../../../static/rectangle.svg";

const Kvalita = () => {

    const [qualities, setQualities] = useState<FrontWebRadioStreamPlaylistModel[]|undefined>(undefined);
    const playedItem = useSelector((app:RootState) => app.playedItem)!;
    const savedQualities = useSelector((app:RootState) => app.qualities);
    const dispatch = useDispatch();
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        if (!playedItem || "programSlug" in playedItem) {
            setQualities(undefined);
        }
        else {
            setQualities(undefined);
            (async () => {
                try {
                    const data = (await new ApiClient().getApiRadioDetail({
                        slug: playedItem.radioSlug,
                    }, {credentials: "include"})).qualities.filter(x => x.type === "hq" || x.type === "lq");
                    if (data)
                        setQualities(data);
                }
                catch(e) {}
                finally {

                }
            })();
        }
        // eslint-disable-next-line
    }, ["id" in playedItem ? playedItem.id : null]);

    useEffect(() => {
        if (qualities && !isScrolled) {

            const x = window.scrollX;
            const y = window.scrollY;
            try {
                window.scrollTo(x, y + 1);
                window.scrollTo(x, y - 2);
                window.scrollTo(x, y + 1);
            }
            catch (e) {

            }
            setIsScrolled(true);
        }
    }, [qualities, isScrolled]);


    if (qualities && "radioSlug" in playedItem) {

        const typeLq = qualities.find(x => (x.type === "lq"));
        const isLq = savedQualities.find(x => x.url === typeLq?.url);
        const lq = qualities.find(x => (x.type === "lq"));
        const hq = qualities.find(x => (x.type === "hq"));
        if (!hq || !lq)
            return null;

        return (
            <li className={"d-flex"}>
                <span>Poslech ve vysoké kvalitě&nbsp;&nbsp;</span>
                <Form>
                    <Form.Check // prettier-ignore
                        style={{
                            marginLeft: "1em",
                            transform: "scale(1.8)"
                        }}
                        onClick={e=>{
                            dispatch<QualityAction>({
                                type: "QualityAction",
                                payload: {
                                    slug: playedItem.radioSlug,
                                    url: isLq ? hq?.url : lq?.url
                                }
                            });
                        }}
                        checked={!isLq}
                        type="switch"
                        id="quality"
                    />
                </Form>
            </li>
        );
    }

    return null;

}

export const More = () => {

    const [selected, setSelected] = useState(0);
    const buttonRef = useRef<HTMLButtonElement|null>(null);

    const playedItem = useSelector((app:RootState) => app.playedItem)!;
    const menu:ReactNode[] = [];

    let errorUrl = "";

    if ("programSlug" in playedItem) {
        const url =(() => {
            if ("radioSlug" in playedItem)
                return routes.radio_program_detail_episode(playedItem.radioSlug, playedItem.programSlug, `${playedItem.id}`, playedItem.name, {}, "episodes");
            return routes.program_detail_episode(playedItem.programSlug, `${playedItem.id}`, playedItem.name, {}, "episodes");
        })()
        errorUrl = url;
        menu.push(<li key="vice"><RouteLink to={url}>
           Více o epizodě
        </RouteLink></li>);
    } else {
        menu.push(<Kvalita />)
        errorUrl = routes.radio_homepage(playedItem.radioSlug, {}, "homepage");
        menu.push(<li key={"vice"}>
            <RouteLink to={errorUrl}>
                Více o rádiu
            </RouteLink>
        </li>);
    }

    menu.push(<li key={"chyba"}>
        <RouteLink to={`/nahlasit-chybu?url=${encodeURIComponent(errorUrl)}`}>
            Nahlásit chybu
        </RouteLink>
    </li>);

    const onHide = useCallback(() =>{
        setSelected(c => {
            c--;
            if (c < 0)
                return 0;
            return c;
        });
    },[]);


    return <>
        <button className={Style.Button} ref={buttonRef} onClick={e=>{
            if (selected)
                setSelected(0);
            else
                setSelected(2);
        }}>
            <img src={selected ? dotmoreselectedsvg: dotmoresvg} alt={"menu"} />
        </button>
        <Overlay target={buttonRef.current} show={!!selected} placement={"top"}>
            {({
                  placement: _placement,
                  arrowProps: _arrowProps,
                  show: _show,
                  popper: _popper,
                  hasDoneInitialMeasure: _hasDoneInitialMeasure,
                  ...props
              }) => (
                <div
                    key={"own"}
                    {...props}
                    style={{
                        position: 'absolute',
                        zIndex:150,
                        padding: '10px 10px',
                        borderRadius: 10,
                        ...props.style,
                        transform: (props.style.transform ?? "") + " translate(0, -50px)"
                    }}
                    className={`${Style.MenuBackground} ${Style.menu}`}
                >
                    <ClickOuterDiv onOutClick={onHide}>
                        <ul className={Style.subMenu}>
                            {menu}
                        </ul>
                    </ClickOuterDiv>
                    <img src={rectanglesvg} alt={""} className={Style.Rectangle} />
                </div>
            )}
        </Overlay>
    </>

}
